import PropsProvider from './PropertiesProvider';

export default {
    __init__: ['fismPropertiesProvider'],
    fismPropertiesProvider: ['type', PropsProvider],
};
